// extracted by mini-css-extract-plugin
export default {"container":"StreamIsOver_container__eT27f","spinner":"StreamIsOver_spinner__fvnRD"};